__turbopack_context__.v({
  "prompt": "web-prompt-module-scss-module__DIzqOq__prompt",
  "prompt-wrapper": "web-prompt-module-scss-module__DIzqOq__prompt-wrapper",
  "prompt__close-button": "web-prompt-module-scss-module__DIzqOq__prompt__close-button",
  "prompt__install-button": "web-prompt-module-scss-module__DIzqOq__prompt__install-button",
  "prompt__message": "web-prompt-module-scss-module__DIzqOq__prompt__message",
});
